export default __webpack_public_path__ + "static/studycafe-office2-3c46e3f2899361bae3a0a763662782a3.jpg";